import Button from '@/components/atoms/Button'
import Icon from '@/components/atoms/Icon'
import Modal from '@/components/atoms/Modal'
import { modalCreators } from '@/store/ducks/modal'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { Dialog } from '@headlessui/react'

interface StatusModalProps {
	disabledOnClose?: boolean
}

export function Status({ disabledOnClose }: StatusModalProps) {
	const {
		modal: { modalInfo },
	} = useAppSelector((state) => state)

	const dispatch = useAppDispatch()

	return (
		<Modal
			name='statusModal'
			disabledOnClose={disabledOnClose}
			className='md:px-10 md:pt-10 md:pb-12 dark:bg-zinc-950 max-w-[520px]'
		>
			<div className='flex flex-col gap-8'>
				<div className='flex flex-col'>
					<div className='flex flex-col gap-4'>
						<div className='flex gap-3 items-center'>
							<Icon name='error-circle' width='22px' height='22px' />
							<Dialog.Title
								as='h3'
								className='text-start text-2xl font-bold leading-7 tracking-tight text-zinc-50'
							>
								{modalInfo?.title || 'Ocorreu um erro'}
							</Dialog.Title>
						</div>
						<p className='text-start w-full text-base text-white/70 leading-[160%]'>
							<span className='font-medium'>
								{modalInfo?.message || 'Erro desconhecido'}
							</span>
						</p>
					</div>
				</div>
				<div className='w-full flex flex-col gap-4'>
					<Button
						className='w-full min-w-full rounded-full'
						onClick={() => dispatch(modalCreators.closeModal())}
					>
						{modalInfo?.buttonLabel || 'Fechar'}
					</Button>
				</div>
			</div>
		</Modal>
	)
}
